import React from 'react';
import { Form, Input, Select, Tag } from 'antd';

import { FileUpload, fileUploadRule } from 'components/FileUpload';
import { CARD_COLORS } from '../../constants';

export const ComplexProgramFormFields = () => {
  return (
    <>
      <Form.Item
        label="Заголовок"
        name="title"
        rules={[{ required: true }]}
      >
        <Input.TextArea
          autoSize
          placeholder="Введите заголовок"
          showCount
          maxLength={50}
        />
      </Form.Item>
      <Form.Item
        label="Краткое описание"
        name="description"
        rules={[{ required: true }]}
      >
        <Input.TextArea
          autoSize
          placeholder="Введите краткое описание"
          showCount
          maxLength={50}
        />
      </Form.Item>
      <Form.Item
        label="Иконка"
        name="icon"
        rules={[{ required: true }, fileUploadRule]}
      >
        {/* @ts-ignore */}
        <FileUpload maxCount={1} name="icon" />
      </Form.Item>
      <Form.Item
        label="Цвет карточки"
        name="color"
        rules={[{ required: true }]}
      >
        <Select placeholder="Выберите цвет карточки">
          {CARD_COLORS.map(color => (
            <Select.Option value={color} key={color}>
              <div style={{ display: 'flex', height: '100%', padding: 5 }}>
                <Tag color={color} style={{ width: '100%', height: '100%' }} />
              </div>
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
    </>
  );
};